import React from 'react';
import {Card, Progress} from "antd";
import {CheckCircleOutlined, ClockCircleOutlined, CloseCircleOutlined, PrinterOutlined} from "@ant-design/icons";

function DeliveryStatisticCard({deliveryData}) {
    return (
        <>

            {/* وضعیت ارسال */}
            <Card title="وضعیت ارسال" className="shadow-sm">
                <div className="flex flex-wrap justify-center gap-8 py-4">
                    <div className="text-center">
                        <Progress
                            type="circle"
                            percent={deliveryData?.pending_percent || 0}
                            size={120}
                            strokeColor="#faad14"
                            format={(percent) => (
                                <div className="text-center">
                                    <div className="text-2xl font-bold">{percent}%</div>
                                    <div className="text-xs  ">در انتظار</div>
                                    <div className="text-xs  ">{deliveryData?.pending_count}</div>
                                </div>
                            )}
                        />
                        <div className="mt-2 text-sm  ">
                            <ClockCircleOutlined /> در انتظار
                        </div>
                    </div>

                    <div className="text-center">
                        <Progress
                            type="circle"
                            percent={deliveryData?.print_percent || 0}
                            size={120}
                            strokeColor="#1677ff"
                            format={(percent) => (
                                <div className="text-center">
                                    <div className="text-2xl font-bold">{percent}%</div>
                                    <div className="text-xs  ">چاپ</div>
                                    <div className="text-xs  ">{deliveryData?.print_count}</div>
                                </div>
                            )}
                        />
                        <div className="mt-2 text-sm  ">
                            <PrinterOutlined /> چاپ
                        </div>
                    </div>

                    <div className="text-center">
                        <Progress
                            type="circle"
                            percent={deliveryData?.deliver_percent || 0}
                            size={120}
                            strokeColor="#52c41a"
                            format={(percent) => (
                                <div className="text-center">
                                    <div className="text-2xl font-bold">{percent}%</div>
                                    <div className="text-xs  ">تحویل</div>
                                    <div className="text-xs  ">{deliveryData?.deliver_count}</div>
                                </div>
                            )}
                        />
                        <div className="mt-2 text-sm  ">
                            <CheckCircleOutlined /> تحویل
                        </div>
                    </div>

                    <div className="text-center">
                        <Progress
                            type="circle"
                            percent={deliveryData?.refund_percent || 0}
                            size={120}
                            strokeColor="#52c41a"
                            format={(percent) => (
                                <div className="text-center">
                                    <div className="text-2xl font-bold">{percent}%</div>
                                    <div className="text-xs  ">مرجوع شده</div>
                                    <div className="text-xs  ">{deliveryData?.refund_count}</div>
                                </div>
                            )}
                        />
                        <div className="mt-2 text-sm   flex gap-1 justify-center">
                            <CloseCircleOutlined />
                            مرجوع شده
                        </div>
                    </div>
                </div>

                {/* نوار پیشرفت تجمعی */}
                <div className="mt-4 px-4 hidden">
                    <div className="flex justify-between text-sm   mb-1">
                        <span>پیشرفت کلی</span>
                        <span>{deliveryData?.deliver_percent || 0}%</span>
                    </div>
                    <Progress
                        percent={deliveryData?.deliver_percent || 0}
                        strokeColor={{
                            '0%': '#faad14',
                            '50%': '#1677ff',
                            '100%': '#52c41a',
                        }}
                        showInfo={false}
                    />
                </div>
            </Card>
        </>
    );
}

export default DeliveryStatisticCard;